import React from 'react';
import { GET_BIN_NUMBERS, VERIFY_CARD, CLEAR_CARDS, LOADER_ACTIVE, UPDATE_CHANGE_START_DATE } from '../../../redux/actionTypes';
import { useEffect, useState } from 'react';
import CardInformation from '../card-information/CardInformation';
import { MONTHS } from '../../helpers/commonHelper';
import { connect } from 'react-redux';
import creditCardService from '../../../shared/credit-card/creditCardService';
import { getSaveCardAPIInfo } from '../../helpers/vanHelpers';
import analyticsService from '../../../shared/analytics/analytics-service';
import Lock from '../../../_styles/images/lock.png';
import config from '../../../appConfig';
import Loading from '../../../shared/loading/Loading';

function BackupCard(props) {

  const [cardNumber, updateCardNumber] = useState('');
  const [maskedCardNumber, updateMaskedCardNumber] = useState('');
  const [cardValid, updateCardValid] = useState(true);
  const [expirationDate, updateExpirationDate] = useState({
    month: MONTHS[new Date().getMonth()],
    year: new Date().getFullYear()
  });
  const [cvv, updateCvv] = useState('');
  const [cvvValid, updateCvvValid] = useState(true);
  const [zip, updateZip] = useState('');
  const [zipValid, updateZipValid] = useState(true);
  const [dateValid, updateDateValid] = useState(true);
  const [cardType, updateCardType] = useState('');
  const [buttonDisabled, updateButtonDisabled] = useState(true);
  const [isFederal, updateIsFederal] = useState(false);
  const [isCvvDisabled, updateCvvDisabled] = useState(true);
  const [previousCards, updatePreviousCards] = useState([]);
  const [commuteCharge, updateCommuteCharge] = useState(null);
  const [isLoading, updateIsLoading] = useState(false);
  const [isCommuter, updateIsCommuter] = useState(false);

  function onDateChange(type, value) {
    updateExpirationDate({
      ...expirationDate,
      [type]: value
    })
  }

  useEffect(() => {
    const existingScript = document.querySelector(`script[src="${config.jsScramblerLink}"]`);
    const script = document.createElement('script');
    if (!existingScript) {
      // Append script
      script.src = config.jsScramblerLink;
      script.async = true;
      script.defer = true;

      document.body.appendChild(script);
    }
    // Cleanup: remove the script when the component unmounts
    return () => {
      document.body.removeChild(script);
    };
  }, []);

  useEffect(() => {
    const today = new Date();
    if (expirationDate.month && expirationDate.year && expirationDate.month < today.getMonth() + 1 && expirationDate.year <= today.getFullYear()) {
      updateDateValid(false)
    } else {
      updateDateValid(true);
    }
  }, [expirationDate])

  function checkCVV(value) {
    let type = creditCardService.getCardTypeJoinCommute(cardNumber);
    if (creditCardService.isCvcValid(type.cvcLength, value)) {
      updateCvv(value);
    }
  }

  function checkZip(value) {
    if (/^\d{0,5}$/.test(value)) {
      updateZip(value);
      if (value.length === 5) {
        updateZipValid(true);
      } else {
        updateZipValid(false);
      }
    }
  }

  function checkCardNumber(value) {
    if (value.length >= 8) {
      const result = creditCardService.checkIfFederalOrCommuterBackup(value, props.binNumbers, props.binNumberArray);
      if(result.isFederal){
        updateIsFederal(result.isFederal);
      }
      // else if(result.mayBeFedCommuter || result.mayBeRetailCommuter){
      //   const cardInfo = props.savedCards[0];
      //   const val = value.replaceAll(' ','');
      //   if( cardInfo.isCommuter && cardInfo.cardNumber.includes(val)){
      //       updateIsCommuter(true)
      //   }
      // }

    } else {
      updateIsFederal(false);
      updateIsCommuter(false);
    }
    value = value.split(' ').join('');
    if (creditCardService.isNumber(value)) {
      const type = creditCardService.getCardTypeJoinCommute(value);
      updateCardType(type);
      value = value.substr(0, Math.max.apply(Math, type.length));
      updateCardNumber(value);
    }
  }

  function onContinue() {
    let chargeAmount = 0;
    commuteCharge
    if (previousCards[0] && previousCards[0].chargeAmount !== commuteCharge) {
      chargeAmount = commuteCharge - previousCards[0].chargeAmount;
    }

    const cardInfo = {
      cardNumber,
      cardType,
      cvv,
      expiry: expirationDate,
      zip,
      isFederal: false,
      isCommuter: false,
      isBackup: true,
      isDefault: false,
      chargeAmount
    }
    props.updateCangeStartDate({ startDate: null, startDateString: null});
    const saveCardInfo = getSaveCardAPIInfo(cardInfo);
    let isBackup =  true;
    props.saveCard(saveCardInfo, cardInfo, props.history, isBackup);
    analyticsService.analyticsProcessEvent({
      "event": "add_backup_card_click_continue",
      "context": {
        "event_action": "continue"
      }
    });
    updateIsLoading(true);
    //props.history.push('/JoinCommute/summary');
  }

  function checkCardInfoValid(cardNumber, cardType, cvv) {
    const isCVVValid = cardType && cvv && cvv.length === cardType.cvcLength;
    if (cvv) {
      updateCvvValid(isCVVValid);
    }
    const isCardNumberValid = cardType && cardNumber && cardType.length.includes(cardNumber.length);
    const isLunh = creditCardService.luhn(cardNumber);
    if (cardNumber && cardType) {
      updateCardValid(isCardNumberValid && cardType.type !== '' && isLunh);
    } else {
      updateCardValid(true);
    }
    return isCVVValid && isCardNumberValid && isLunh;
  }

  useEffect(() => {
    const isValid = checkCardInfoValid(cardNumber, cardType, cvv, zip);
    if (cardNumber && cardType && cvv && zip && expirationDate && isValid && !isFederal && zipValid && dateValid) {
      updateButtonDisabled(false);
    } else {
      updateButtonDisabled(true);
    }
  }, [cardNumber, cardType, cvv, zip, expirationDate, zipValid, dateValid]);

  useEffect(() => {
    if(props.isCardSaving){
      props.updateLoading(true);
    }
    if (!props.isBinLoaded) {
      props.getBinNumbers();
    }
    if (props?.savedCards?.length > 1 && props.savedCards[1]?.maskedCreditCardNumber) {
      const cardInfo = props.savedCards[1];
      updateCardNumber(cardInfo.cardNumber);
      updateMaskedCardNumber(cardInfo.maskedCreditCardNumber);
      updateCardType(cardInfo.cardType);
      updateExpirationDate({
      month: cardInfo.expiry.month,
      year: cardInfo.expiry.year
    });
    }
  }, [])

  useEffect(() => {
    if(!props.isCardSaving){
      props.updateLoading(false);
    }
  }, [props.isCardSaving])

  useEffect(() => {
    if (!cardValid || cardNumber == '') {
      checkCVV('');
      updateCvvDisabled(true);
    } else {
      updateCvvDisabled(false);
    }
  }, [cardValid, cardNumber])

  useEffect(() => {
    updatePreviousCards(props.cards);
  }, [props.cards]);

  useEffect(() => {
    updateCommuteCharge(props.commuteCharge);
  }, [props.commuteCharge])

  useEffect(() => {
    updateIsLoading(props.stopPaymnetScreenLoader);
  }, [props.stopPaymnetScreenLoader])

  function clearAllPaymentData(){
    updateMaskedCardNumber(''); 
    updateCardNumber(''); 
    updateCardType({ type: '', pattern: /.*/, length: [16], luhn: true, cvcLength: 3, imgSrc: `${config.imagePath}/DefaultCard.png` });
    updateIsFederal(false);
    updateIsCommuter(false);
    updateExpirationDate({month: MONTHS[new Date().getMonth()], year: new Date().getFullYear()})
  }

  return (
    <div className='payment-page'>
       <Loading isLoading={isLoading} />
      <div className='payment-container'>
          <div className='heading'>Add a Secondary Card</div>

        {/* {
          props.findAVan ?
          <div className='comment'>Please add your payment information for a credit, debit, Federal Benefit.</div> :
          <div className='comment'>In case your Federal Benefit card does not have enough funds to cover monthly charges, please add a backup card</div> 
        } */}
      
        {
           ( props.findAVan && props.summaryData?.isRetailRequiredForRecurringPayment ) || props.fromRecurringFlow ?

            <div className='comment'>To proceed please add a secondary credit or debit card to cover the recurring subscription cost.</div>
            :
            <div className='comment'>To proceed please add a secondary credit or debit card to cover the first month's cost.</div> 
            
        }
         {/* <div className='comment'>Please add your payment information for a credit or debit card.</div> */}
        <div className='sub-heading'>Card Information</div>
        <CardInformation
          cardType={cardType}
          cardValid={cardValid}
          cardNumber={cardNumber}
          expirationDate={expirationDate}
          checkCardNumber={checkCardNumber}
          onDateChange={onDateChange}
          cvv={cvv}
          checkCVV={checkCVV}
          zip={zip}
          checkZip={checkZip}
          cvvValid={cvvValid}
          federalIssue={isFederal}
          isCvvDisabled={isCvvDisabled}
          zipValid={zipValid}
          dateValid={dateValid}
          maskedCCNumber={maskedCardNumber}
          commuterIssue={isCommuter}
          deleteMaskedNumber={() => clearAllPaymentData()}/>

        {<div className={`legal-copy ${(isFederal || !zipValid || !cvvValid) ? 'federal' : ''}`}>
          <div className='lock-image'>
            <img src={Lock} aria-hidden='true' />
          </div>
          <div className='legal-copy-text'>
            Your information will be submitted over a secure connection. <br />
            For additional information, please review our
            {' '}
            <a
              href={config.privacyPolicyLink}
              target="_blank"
              rel="noopener noreferrer"
              className='link'
            >
              Privacy Policy
            </a>
            {' '}and{' '}
            <a
              href={config.termsOfUseLink}
              target="_blank"
              rel="noopener noreferrer"
              className='link'
            >
              Terms of Use{' '}
            </a>
          </div>
        </div>}
        <button tabIndex={0} disabled={buttonDisabled} className='continue-button' onClick={onContinue}>continue</button>
      </div>
    </div>
  );
}

function mapStateToProps(state) {
  return {
    binNumbers: state.joinCommute.payment.binNumbers,
    cards: state.joinCommute.payment.cards,
    commuteCharge: state.joinCommute.userCommuteData.charge,
    maxAmount: state.joinCommute.payment.maxAmount,
    isDesiredDriverRole: state.joinCommute.drivingScheduleData.isDesiredDriverRole,
    isBinLoaded: state.joinCommute.payment.isBinLoaded,
    savedCards: state.joinCommute.payment.cards,
    isCardSaving: state.joinCommute.payment.isCardSaving,
    stopPaymnetScreenLoader: state.joinCommute.stopPaymnetScreenLoader,
    summaryData: state.joinCommute.userCommuteData.summaryData,
    fromRecurringFlow: state.joinCommute.fromRecurringFlow,
    binNumberArray: state.joinCommute.payment.binNumberArray,
  }
}

function mapDispatchToProps(dispatch) {
  return {
    getBinNumbers() {
      dispatch({ type: GET_BIN_NUMBERS })
    },
    saveCard(saveInfo, cardInfo, history, isBackup, flow, isPrimary) {
      dispatch({ type: VERIFY_CARD, data: cardInfo, saveInfo, history, isBackup, flow, isPrimary })
    },
    clearCards() {
      dispatch({ type: CLEAR_CARDS })
    },
    updateLoading(data) {
      dispatch({ type: LOADER_ACTIVE, data });
    },
    updateCangeStartDate(date) {
      dispatch({ type: UPDATE_CHANGE_START_DATE, data: date });
    },
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(BackupCard);